<script setup lang="ts">
import { RouterLink } from 'vue-router';
import { ArrowLeft, Compass } from '@lucide/vue';
import MarchioEvolfin from '@/components/app/MarchioEvolfin.vue';
import SfondoAmbiente from '@/components/app/SfondoAmbiente.vue';

/**
 * Pagina d'errore: è una delle schermate iconiche, quindi condivide
 * con il login lo sfondo ambientale e la card di vetro. Il tono resta utile e
 * sobrio: dice cosa è successo e offre la via d'uscita.
 */
</script>

<template>
  <div class="relative grid min-h-screen place-items-center overflow-hidden px-4 py-12">
    <SfondoAmbiente />

    <main class="relative w-full max-w-[400px]">
      <header class="entra mb-7 flex flex-col items-center text-center">
        <MarchioEvolfin :dimensione="60" />
        <h1 class="mt-5 font-display text-[32px] leading-[1.07] font-semibold">
          Pagina non trovata
        </h1>
      </header>

      <!-- Empty state curato: icona in contenitore soft → spiegazione → CTA. -->
      <div
        class="entra card card--vetro bordo-riflesso flex flex-col items-center gap-4 p-7 text-center"
        style="animation-delay: 60ms"
      >
        <span
          class="grid size-12 place-items-center rounded-md bg-[var(--surface-accent-soft)]"
          aria-hidden="true"
        >
          <Compass :size="24" :stroke-width="1.7" class="text-[var(--color-primary)]" />
        </span>

        <p class="text-ink-secondary">
          L’indirizzo che hai aperto non corrisponde a nessuna schermata di Evolfin.
        </p>

        <RouterLink
          to="/dashboard"
          class="inline-flex items-center gap-2 rounded-sm bg-[var(--color-primary)] px-4 py-2.5 font-medium text-[var(--color-on-primary)] shadow-[var(--shadow-btn-primary)] transition-colors hover:bg-[var(--color-primary-hover)]"
        >
          <ArrowLeft :size="16" :stroke-width="2" aria-hidden="true" />
          Torna alla dashboard
        </RouterLink>
      </div>
    </main>
  </div>
</template>
